import React from 'react';
import {
  Text,
  Box,
  Flex,
  COLORS,
  Icon,
  Heading,
  Divider as PodiumDivider,
} from '@podiumhq/design-system';
import styled from 'styled-components/macro';
import useMediaQuery from 'hooks/useMediaQuery';
import { MEDIUM_MEDIA_QUERY_WIDTH } from 'styles';

const FakeModal = ({ children, showIcon = true, marginTop }) => {
  const isMobile = useMediaQuery();

  return (
    <>
      {isMobile ? (
        <Wrapper>
          {showIcon && (
            <Icon
              boxSize={5}
              fill={COLORS.black.base}
              sx={{ svg: { fill: 'black.base' } }}
              color="black.base"
              type="Logo"
              marginBottom="24px"
            />
          )}
          <Animate>{children}</Animate>
        </Wrapper>
      ) : (
        <Flex justifyContent="center">
          <Box
            position="fixed"
            zIndex="10"
            top="50%"
            margin={marginTop ? `${marginTop}px 18px 18px 18px` : '18px'}
            transform="translate(0, -50%)"
            background="silver.lightest"
            boxShadow="0px 0px 0px 0.5px rgba(18, 21, 26, 0.08),
	0px 8px 16px rgba(18, 21, 26, 0.02),
	0px 16px 32px -4px rgba(18, 21, 26, 0.04),
	0px 32px 64px -8px rgba(18, 21, 26, 0.04)"
            borderRadius="16px"
            padding="24px"
            width="512px"
          >
            <Icon
              boxSize={5}
              fill={COLORS.black.base}
              sx={{ svg: { fill: 'black.base' } }}
              color="black.base"
              type="Logo"
              marginBottom="24px"
            />
            <Animate>{children}</Animate>
          </Box>
        </Flex>
      )}
    </>
  );
};

const Divider = () => (
  <StyledPodiumDivider
    width="auto"
    marginLeft="-24px"
    marginRight="-24px"
    marginTop="24px"
    marginBottom="24px"
  />
);

const Header = ({ children }) => (
  <Heading fontWeight="semibold">{children}</Heading>
);
const Body = ({ children }) => <Text>{children}</Text>;

FakeModal.Divider = Divider;
FakeModal.Header = Header;
FakeModal.Body = Body;

export default FakeModal;

export const Animate = styled.div`
  animation: wiggleWiggle 0.25s ease-in-out;
  @keyframes wiggleWiggle {
    0% {
      transform: translateX(24px);
      opacity: 0;
    }
    50% {
      transform: translateX(-10px);
    }
    100% {
      transform: translateX(0);
      opacity: 1;
    }
  }
`;

const StyledPodiumDivider = styled(PodiumDivider)`
  @media (max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px) {
    display: none;
  }
`;

const Wrapper = styled.div`
  padding: 24px;
`;
